
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jumpstart-mw-ri-trial",
      function () {
        return require("private-next-pages/jumpstart-mw-ri-trial/index.js");
      }
    ]);
  